import enviro from 'enviro';
import { useGetAiAccessControls } from '../../aiControl/aiAccessQueries';
import { useDisplayInteractiveEducation } from '../hooks/hooks';
import { useUserIndustry } from '../hooks/useUserIndustry';
import { isInternalPortal } from '../../accounts';
import { useVideoPlayerCaptions } from '../../video/videoHooks';
export const useInteractiveEducation = ({
  videoId,
  creatorRegion,
  contentPortalId,
  interactiveContentTrackingProps
}) => {
  const {
    aiAccessControls
  } = useGetAiAccessControls();
  const {
    captionsAvailable
  } = useVideoPlayerCaptions(videoId, creatorRegion, contentPortalId);
  const aiEnabled = !!(aiAccessControls !== null && aiAccessControls !== void 0 && aiAccessControls.generativeAiEnabled);
  const interactiveEducationEnabled = aiEnabled && captionsAvailable;
  const {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation
  } = useDisplayInteractiveEducation(interactiveContentTrackingProps, videoId);

  // Feature flag to enable/disable "Adapt to Industry" feature
  const enableAdaptToIndustry = enviro.isQa() || isInternalPortal();
  useUserIndustry();
  return {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation,
    interactiveEducationEnabled,
    enableAdaptToIndustry
  };
};